// Copyright 2019 Sorama B.V.
/* eslint-disable @typescript-eslint/no-explicit-any */
// Disable any check for this file inputContent and searchProperties are unknown[] and not a specific type

import { customElement, observable, bindable, bindingMode, BindingEngine, Disposable } from "aurelia-framework";

@customElement("search-bar")
export class SearchBar {
    @bindable({ defaultBindingMode: bindingMode.oneWay })
    public searchProperties: any[];

    @bindable({ defaultBindingMode: bindingMode.oneWay })
    public inputContent: any[];

    @bindable({ defaultBindingMode: bindingMode.toView })
    public outputContent: any[];

    @bindable({ defaultBindingMode: bindingMode.fromView })
    public value: string;

    private collectionObserver: Disposable;

    constructor(private bindingEngine: BindingEngine = undefined) {}

    public bind(): void {
        this.inputContentChanged();
        this.doFilter();
    }

    public unbind(): void {
        if (this.collectionObserver) {
            this.collectionObserver.dispose();
            this.collectionObserver = undefined;
        }
    }

    private inputContentChanged(): void {
        if (this.collectionObserver) {
            this.collectionObserver.dispose();
            this.collectionObserver = undefined;
        }

        if (this.inputContent) {
            this.collectionObserver = this.bindingEngine.collectionObserver(this.inputContent).subscribe(() => {
                this.doFilter();
            });

            this.doFilter();
        }
    }

    private userInputTypedChanged(): void {
        this.doFilter();
    }

    public doFilter(): void {
        if (this.outputContent && this.outputContent.length > 0) {
            this.outputContent.splice(0, this.outputContent.length);
        }

        if (this.inputContent && this.searchProperties) {
            for (let i = 0; i < this.inputContent.length; i++) {
                const currentElement = this.inputContent[i];

                for (let j = 0; j < this.searchProperties.length; j++) {
                    if (
                        currentElement.some((x) => {
                            const currentPropertyToBeFiltered = this.getObjAttribute(this.searchProperties[j], x);
                            return (
                                !this.value ||
                                (currentPropertyToBeFiltered &&
                                    currentPropertyToBeFiltered.toLowerCase().indexOf(this.value) !== -1)
                            );
                        })
                    ) {
                        this.outputContent.push(currentElement);
                        break;
                    }
                }
            }
        }
    }

    public getObjAttribute(path: string, obj: any): any {
        return path.split(".").reduce((prev, curr) => {
            return prev ? prev[curr] : null;
        }, obj || self);
    }
}
